import { useMutation, useQuery } from "@tanstack/react-query";
import type { FeatureClient } from "@/config/client";
import { queries } from "./index";

export const useLogoQuery = (client: FeatureClient) => {
	return useQuery({
		queryKey: queries.settings.logo.queryKey,
		queryFn: client.getLogo,
	});
};

export const useFaviconQuery = (client: FeatureClient) => {
	return useQuery({
		queryKey: queries.settings.favicon.queryKey,
		queryFn: client.getFavicon,
	});
};

export const useStorePicQuery = (client: FeatureClient) => {
	return useQuery({
		queryKey: queries.settings.storePic.queryKey,
		queryFn: client.getStorePic,
	});
};

export const usePublicSettingsQuery = (client: FeatureClient) => {
	return useQuery({
		queryKey: queries.settings.publicSettings.queryKey,
		queryFn: client.getPublicSettings,
	});
};

export const useSetLogoMutation = (client: FeatureClient) => {
	return useMutation({
		mutationKey: queries.settings.logo.queryKey,
		mutationFn: client.setLogo,
	});
};

export const useSetFaviconMutation = (client: FeatureClient) => {
	return useMutation({
		mutationKey: queries.settings.favicon.queryKey,
		mutationFn: client.setFavicon,
	});
};

export const useSetPublicSettingsMutation = (client: FeatureClient) => {
	return useMutation({
		mutationKey: queries.settings.publicSettings.queryKey,
		mutationFn: (param: {
			name: string;
			label: string;
			isPublic: boolean;
			valueString: any;
		}) => client.setSetting(param.name, param),
	});
};

export const useSystemSettingsQuery = (client: FeatureClient) => {
	return useQuery({
		queryKey: queries.settings.settings.queryKey,
		queryFn: client.getAllSettings,
	});
};
